import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, IconButton, Zoom } from '@mui/material';
import { X } from 'lucide-react';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Zoom ref={ref} {...props} />;
});
export default function CustomShowModal(props) {

    const { open, handleClose, maxWidth = "sm", title = 'Stores' } = props;

    return (
        <div>
            <Dialog
                open={open}
                scroll='paper'
                fullWidth
                TransitionComponent={Transition}
                maxWidth={maxWidth}
                aria-labelledby="customized-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <h3 style={{ color: '#F1F5F9' }}>{title}</h3>
                        <IconButton onClick={handleClose} sx={{ color: '#94A3B8' }}>
                            <X size={20} />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    {props.children}
                </DialogContent>
            </Dialog>
        </div>
    );
}
